import { render } from "./ProposalPayment.vue?vue&type=template&id=62ae64dc"
import script from "./ProposalPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalPayment.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/ProposalPayment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62ae64dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62ae64dc', __exports__)) {
    api.reload('62ae64dc', __exports__)
  }
  
  module.hot.accept("./ProposalPayment.vue?vue&type=template&id=62ae64dc", () => {
    api.rerender('62ae64dc', render)
  })

}


export default __exports__